import React from 'react';
import propTypes from 'prop-types';
import _ from 'lodash';
import { FeatureCard } from '_ui-core-js/React/components/FeatureCard.jsx';
import { Carousel } from '_ui-core-js/React/components/Carousel.jsx';
import { AnimatedTextHeader } from '_ui-core-js/React/components/AnimatedTextHeader.jsx';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { LBX_GTM_TRACKING_VALUES } from '../../constants/analytics.js';

const gtmComponentGroup = CORE_GTM_TRACKING_VALUES.componentGroup.newCars;
const gtmComponentName = LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceStory;

export function NewsAndStories(props) {

  const { intro, carousel } = props;
  const block = 'c-news-and-stories';

  return (
	<div 
		className={`${block} utils__section-padding--uniform`}
		role='complementary'
	>
	  {
		intro && (
		  <AnimatedTextHeader
		  heading={intro.heading}
		  subheading={intro.subheading}
		  />
	  	)
	  }
	  {
		carousel && (
			<Carousel 
		  	centered={true} 
		  	infinite={true} 
		  	pagination={true}
		  	uniformHeight={false}
      	 	gtmComponentName={gtmComponentName}
      		gtmComponentGroup={gtmComponentGroup}
      		gtmAction={CORE_GTM_TRACKING_VALUES.action.browseStory}
		  >
			{
			  carousel.items?.map((item, index) => (
				<FeatureCard 
				key={index}
				mediaMaintainAspect={true}
				headingSize='h4'
				{ ...item }
          		gtmComponentName={gtmComponentName}
         		gtmComponentGroup={gtmComponentGroup}    
				onClickCallback={ () => {
					
					const href = _.get(item, 'link.href');
					const hasQueryString = _.includes(href, '?');
					const symbol = hasQueryString ? '&' : '?';

					if (href) {
						T1.pageOverlayer.open({
							url: `${href}${symbol}hideNav=true&hideFooter=true`, 
							type:'iframe', 
							size:'fullscreen'
						})
					}
				}}
				/>
			  ))
			}
		  </Carousel>
		)
	  }
	</div>
  )
};

NewsAndStories.propTypes = {
  intro: propTypes.object,
  carousel: propTypes.object.isRequired
};